export const loadPdfLogoDataUrl = () =>
  new Promise((resolve) => {
    const logoImg = new Image();
    logoImg.crossOrigin = "anonymous";

    logoImg.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        const maxSize = 320;
        const scale = Math.min(
          maxSize / logoImg.width,
          maxSize / logoImg.height,
          1
        );

        canvas.width = Math.max(1, Math.round(logoImg.width * scale));
        canvas.height = Math.max(1, Math.round(logoImg.height * scale));

        const ctx = canvas.getContext("2d");
        if (!ctx) {
          resolve(null);
          return;
        }

        ctx.drawImage(logoImg, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", 0.82));
      } catch (error) {
        console.error("Failed to process logo for PDF:", error);
        resolve(null);
      }
    };

    logoImg.onerror = () => resolve(null);
    logoImg.src = `${window.location.origin}/logo.jpeg`;
  });
